import { AnyAction } from '@reduxjs/toolkit';
import { GetCustomerUsersRoutine } from '../redux-routines';
import { REMOVE_USER } from '../action-types';
import type { IRemoveUserAction } from '../actions';
import type { ICustomerUsersState } from '../interfaces';

export const initialState: ICustomerUsersState = {
  data: [],
  externalUsers: [],
  error: null,
  isFetching: false,
  externalIdentifications: [],
};

export const customerUsersReducer = (
  state: ICustomerUsersState = initialState,
  action: AnyAction,
): ICustomerUsersState => {
  switch (action.type) {
    case GetCustomerUsersRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case GetCustomerUsersRoutine.SUCCESS: {
      const payload = GetCustomerUsersRoutine.getSuccessPayload(action);
      return {
        ...state,
        data: payload.ownUsers,
        externalUsers: payload.externalCustomerUsers,
        externalIdentifications: payload.externalIdentifications,
        isFetching: false,
      };
    }
    case REMOVE_USER:
      return {
        ...state,
        data: state.data.filter((i) => i.userId !== (action as IRemoveUserAction).userId),
      };
    case GetCustomerUsersRoutine.FAILURE: {
      return {
        ...state,
        error: GetCustomerUsersRoutine.getFailurePayload(action),
        isFetching: false,
      };
    }
    default:
      return state;
  }
};
